/**
 * Feature Flags for the Editor
 *
 * These flags control experimental or in-development features.
 * Set to true to enable the feature, false to use the legacy behavior.
 */

/**
 * USE_SETUP_WIZARD_FLOW
 *
 * When ENABLED (true):
 *   - Hides the template selection in the New Project dialog
 *   - Automatically selects the 'empty' template
 *   - Simulates a new flow where the project starts empty and is built
 *     collaboratively with an AI agent (setup wizard)
 *
 * When DISABLED (false):
 *   - Shows the full template selection UI as normal
 *   - User can pick any available template
 */
export const USE_SETUP_WIZARD_FLOW = false;

/**
 * USE_SDK_AGENT_CHAT
 *
 * When ENABLED (true):
 *   - Shows the docked SDK agent chat panel on the left of the viewport
 *   - Agent Nova visibility is controlled by Editor Tools > Agent Nova (Dev)
 *
 * When DISABLED (false):
 *   - Disables SDK agent chat UI entry points in the editor
 */
export const USE_SDK_AGENT_CHAT = true;
